export const frontendURL = (path, params) => {
  const stringifiedParams = params ? `?${new URLSearchParams(params)}` : '';
  return `/app/${path}${stringifiedParams}`;
};

export const conversationUrl = ({
  accountId,
  activeInbox,
  id,
  label,
  autolabel,
  teamId,
  conversationType = '',
  foldersId,
  favoriteId,
  aiViewType,
}) => {
  let url = `accounts/${accountId}/conversations/${id}`;

  if (activeInbox) {
    if (favoriteId) {
      url = `accounts/${accountId}/favorite/${favoriteId}/inbox/${activeInbox}/conversations/${id}`;
    } else {
      url = `accounts/${accountId}/inbox/${activeInbox}/conversations/${id}`;
    }
  } else if (autolabel) {
    url = `accounts/${accountId}/autolabel/${autolabel}/conversations/${id}`;
  } else if (label) {
    if (favoriteId) {
      url = `accounts/${accountId}/favorite/${favoriteId}/label/${label}/conversations/${id}`;
    } else {
      url = `accounts/${accountId}/label/${label}/conversations/${id}`;
    }
  } else if (teamId) {
    url = `accounts/${accountId}/team/${teamId}/conversations/${id}`;
  } else if (foldersId && foldersId !== 0) {
    if (favoriteId) {
      url = `accounts/${accountId}/favorite/${favoriteId}/custom_view/${foldersId}/conversations/${id}`;
    } else {
      url = `accounts/${accountId}/custom_view/${foldersId}/conversations/${id}`;
    }
  } else if (conversationType === 'ai_agent') {
    const viewType = aiViewType || 'open';
    url = `accounts/${accountId}/ai-view/${viewType}/conversations/${id}`;
  } else if (conversationType === 'mention') {
    url = `accounts/${accountId}/mentions/conversations/${id}`;
  } else if (conversationType === 'participating') {
    url = `accounts/${accountId}/participating/conversations/${id}`;
  } else if (conversationType === 'unattended') {
    url = `accounts/${accountId}/unattended/conversations/${id}`;
  }
  return url;
};

export const conversationListPageURL = ({
  accountId,
  conversationType = '',
  inboxId,
  label,
  teamId,
  customViewId,
  aiViewType,
}) => {
  let url = `accounts/${accountId}/dashboard`;
  if (label) {
    url = `accounts/${accountId}/label/${label}`;
  } else if (teamId) {
    url = `accounts/${accountId}/team/${teamId}`;
  } else if (inboxId) {
    url = `accounts/${accountId}/inbox/${inboxId}`;
  } else if (customViewId) {
    url = `accounts/${accountId}/custom_view/${customViewId}`;
  } else if (conversationType) {
    const urlMap = {
      mention: 'mentions/conversations',
      unattended: 'unattended/conversations',
      ai_agent: `ai-view/${aiViewType || 'open'}`,
    };
    url = `accounts/${accountId}/${urlMap[conversationType]}`;
  }
  return frontendURL(url);
};

export const isValidURL = value => {
  /* eslint-disable no-useless-escape */
  const URL_REGEX =
    /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)$/gm;
  return URL_REGEX.test(value);
};

export const getArticleSearchURL = ({
  host,
  portalSlug,
  pageNumber,
  locale,
  status,
  authorId,
  categorySlug,
  sort,
  query,
  isSearchSubstring,
}) => {
  const queryParams = new URLSearchParams({});

  const params = {
    page: pageNumber,
    locale,
    status,
    author_id: authorId,
    category_slug: categorySlug,
    sort,
    query,
  };

  // add is_search_substring if query is present
  if (query) {
    params.is_search_substring = isSearchSubstring;
  }

  Object.entries(params).forEach(([key, value]) => {
    if (value !== null && value !== undefined) {
      queryParams.set(key, value);
    }
  });

  return `${host}/${portalSlug}/articles?${queryParams.toString()}`;
};

// TODO we don't need this validation: https://gitlab.com/commslayer/app/-/merge_requests/656
// This validation is for: if there is avatar from Gravatar, dont show the delete button
// Latest version on Chatwoot doesn't validate the url from Gravatar
export const hasValidAvatarUrl = avatarUrl => {
  try {
    const { host: avatarUrlHost } = new URL(avatarUrl);
    const isFromGravatar = ['www.gravatar.com', 'gravatar'].includes(
      avatarUrlHost
    );
    return avatarUrl && !isFromGravatar;
  } catch (error) {
    return false;
  }
};
